"use client";

import React from "react";
import { Mail } from "lucide-react";
import { ContactMethodActions } from "./ContactMethodActions";
import type { User } from "@/lib/types/user";

interface AdminUserEmailLinkProps {
  user: Pick<User, "email" | "first_name" | "last_name" | "id">;
  className?: string;
  showIcon?: boolean;
}

export function AdminUserEmailLink({
  user,
  className,
  showIcon = false,
}: AdminUserEmailLinkProps) {
  const email = user.email?.trim();
  if (!email) return null;

  const displayName = [user.first_name, user.last_name].filter(Boolean).join(" ").trim();

  return (
    <span className={className ?? "inline-flex items-center gap-1 min-w-0"}>
      {showIcon ? <Mail className="h-3.5 w-3.5 flex-shrink-0" /> : null}
      <ContactMethodActions
        kind="email"
        value={email}
        entityContext={{
          item: {
            id: user.id,
            email,
            name: displayName || email,
          },
        }}
      />
    </span>
  );
}
